import React from 'react';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import css from './SFLoader.scss';

export default class SFLoader extends React.Component {
  render() {
    return <Dimmer.Dimmable className={css['loader']} as={Segment} blurring dimmed>
      <Dimmer active inverted><Loader size="big">{this.props.children}</Loader></Dimmer>
    </Dimmer.Dimmable>
  }
}

SFLoader.defaultProps = {
  children: "Loading items..."
};

SFLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
